import React, { useState } from "react";
import { IoIosAdd } from "react-icons/io";
import Toast from "./Toast";

function CreateArea({ onAdd }) {
    const [isExpanded, setExpanded] = useState(false);
    const [showToast, setShowToast] = useState(false);
    const [note, setNote] = useState({
        title: "",
        content: "",
    });

    function handleChange(e) {
        const { name, value } = e.target;
        setNote((prevValue) => ({
            ...prevValue,
            [name]: value,
        }));
    }

    function handleExpanded() {
        setExpanded(true);
    }

    function submitButton(event) {
        event.preventDefault();
        if (note.title.trim() === "" && note.content.trim() === "") {
            setShowToast(true);
            return;
        }

        onAdd(note);
        setNote({
            title: "",
            content: "",
        });
    }

    return (
        <div>
            <Toast
                message="Non puoi creare una nota vuota!"
                show={showToast}
                onClose={() => setShowToast(false)}
            />
            <form className="animate__animated animate__fadeInUp">
                {isExpanded && (
                    <input
                        value={note.title}
                        type="text"
                        placeholder="Title"
                        name="title"
                        onChange={handleChange}
                    />
                )}
                <p>
                    <textarea
                        value={note.content}
                        onClick={handleExpanded}
                        name="content"
                        placeholder="Create a note"
                        onChange={handleChange}
                    />
                </p>
                <button onClick={submitButton}>
                    <IoIosAdd size={40} />
                </button>
            </form>
        </div>
    );
}

export default CreateArea;